export const blockIconsHouseholdSensorOccupiedNew = (
	<span className='material-symbols-outlined'>sensor_occupied</span>
);
